import { useState, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setCookie } from '../utils/cookies';
import { logout } from '../redux/slices/authSlice';
import { clearDateArr } from '../redux/slices/clubsSlice';
import { setLogoutCheck } from '../redux/slices/interfaceSlice';
import {
  Home,
  ClipboardList,
  CalendarDays,
  Ticket,
  History,
  BoneIcon,
  Star,
  CalendarCheck,
  BookOpen,
  FileCheck,
  FileSignature,
  FileText,
  Upload,
} from 'lucide-react';
import { useGetClientQuery } from '@/queries/useGetClientQuery';
import { getCookie } from '../utils/cookies';

export const useMenu = (onOpenChange: (open: boolean) => void) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [logoutDialogOpen, setLogoutDialogOpen] = useState<boolean>(false);
  const { data: clientData } = useGetClientQuery();
  const userName = useMemo(() => {
    if (clientData) return `${clientData.name} ${clientData.last_name}`;

    return '';
  }, [clientData]);
  const handleLogout = () => {
    dispatch(clearDateArr());
    dispatch(setLogoutCheck(true));
    dispatch(logout());
    setCookie('isAuth', 'false');
    localStorage.clear();
    navigate('/login');
    setLogoutDialogOpen(false);
    onOpenChange(false);
  };

  const handleLogoutClick = () => {
    setLogoutDialogOpen(true);
    onOpenChange(false);
  };

  const menuItems = [
    {
      to: '/home',
      icon: <Home className="h-4 w-4" />,
      text: 'Главная',
    },
    {
      to: '/classes',
      icon: <ClipboardList className="h-4 w-4" />,
      text: 'Мои занятия',
    },
    {
      to: '/sign-up',
      icon: <CalendarDays className="h-4 w-4" />,
      text: 'Расписание',
    },
    {
      to: '/tickets',
      icon: <Ticket className="h-4 w-4" />,
      text: 'Абонементы',
    },
    {
      to: '/purchase_history',
      icon: <History className="h-4 w-4" />,
      text: 'Последние оплаты',
    },
    {
      to: '/bonuses',
      icon: <Star className="h-4 w-4" />,
      text: 'Бонусный счет',
    },
    {
      to: '/visits_history',
      icon: <CalendarCheck className="h-4 w-4" />,
      text: 'История посещений',
    },
    {
      to: '/achievements',
      icon: <BookOpen className="h-4 w-4" />,
      text: 'Дневник пловца',
    },
    {
      to: '/certificates',
      icon: <FileText className="h-4 w-4" />,
      text: 'Cправки',
    },
    {
      to: '/fileuploader',
      icon: <Upload className="h-4 w-4" />,
      text: 'Отправка видео и фото',
    },
  ];
  return {
    menuItems,
    handleLogoutClick,
    logoutDialogOpen,
    handleLogout,
    setLogoutDialogOpen,
    userName,
  };
};
